import { useState } from "react";
import { Eye, EyeOff, Loader2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import loginBackground from "../../assets/img/Group.png";
import loginImage from "../../assets/img/LoginImage.png";
import { saveAuthSession, login } from "../../api/authApi";
import { showError, showSuccess } from "../../utils/ alert";
import { getHomePath, isKnownRole } from "../../lib/roleAccess";


export default function Login() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberLogin, setRememberLogin] = useState(false);

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email || !password) {
      setErrorMessage("Please enter both email and password.");
      return;
    }

    try {
      setLoading(true);
      setErrorMessage("");

      const response = await login({ email, password });

      // Role kosong/tidak dikenal: jangan simpan sesi (akses paling terbatas).
      if (!isKnownRole(response.data.user?.role)) {
        setErrorMessage("Akun Anda belum memiliki role yang dikenali. Hubungi admin.");
        return;
      }

      saveAuthSession(response.data.token, response.data.user, rememberLogin);

      await showSuccess("Successfully login!")

      navigate(getHomePath(response.data.user.role));
    } catch (error: any) {
      showError(
        "Failed",
        "Failed to Login."
    );

      if (error?.response?.status === 401) {
        setErrorMessage("Invalid email or password.");
      } else {
        setErrorMessage("Something went wrong. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };



  return (
    <div
      className="relative min-h-screen bg-cover bg-center bg-fixed bg-no-repeat"
      style={{
        backgroundImage: `url(${loginBackground})`,
      }}>
      <div className="absolute inset-0 bg-black/45 backdrop-blur-[2px]" />

      <div className="relative flex min-h-screen items-center justify-center px-6">
        <div className="w-full max-w-5xl rounded-[32px] bg-white shadow-2xl overflow-hidden">
          <div className="grid md:grid-cols-2">
            {/* LEFT */}
            <div className="flex flex-col justify-center px-16 py-14">
              <h1 className="text-4xl font-bold text-gray-900">
                Log in to your account
              </h1>

              <p className="text-gray-400 mt-2 mb-10">
                Welcome back, please enter your detail!
              </p>

              <form onSubmit={handleSubmit} className="space-y-5">
                {errorMessage && (
                  <div className="rounded-lg bg-red-50 px-4 py-3 text-sm text-red-600">
                    {errorMessage}
                  </div>
                )}

                <div>
                  <label className="text-sm text-gray-500">Email</label>

                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                    autoComplete="email"
                    className="mt-2 w-full rounded-lg border px-4 py-3 outline-none focus:border-teal-500"
                  />
                </div>

                <div>
                  <label className="text-sm text-gray-500">Password</label>

                  <div className="relative mt-2">
                    <input
                      type={showPassword ? "text" : "password"}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="Enter your password"
                      autoComplete="current-password"
                      className="w-full rounded-lg border px-4 py-3 pr-12 outline-none focus:border-teal-500"
                    />

                    <button
                      type="button"
                      onClick={() => setShowPassword((prev) => !prev)}
                      className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                      tabIndex={-1}>
                      {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                    </button>
                  </div>
                </div>

                <div className="flex items-center justify-between text-sm">
                  <label className="flex items-center gap-2 text-gray-500">
                    <input
                      type="checkbox"
                      checked={rememberLogin}
                      onChange={(e) => setRememberLogin(e.target.checked)}
                    />
                    Remember login
                  </label>

                  <button type="button" className="text-blue-500">
                    Forgot password
                  </button>
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="mt-2 flex w-full items-center justify-center gap-2 rounded-lg bg-[#234B4D] py-3 font-semibold text-white hover:bg-[#1b3d3f] disabled:opacity-50">
                  {loading && <Loader2 className="animate-spin" size={18} />}
                  {loading ? "Logging in..." : "Login"}
                </button>

              
              </form>
            </div>

            {/* RIGHT */}
            <div className="flex items-center justify-center bg-[#FAFAFA] p-10">
              <img src={loginImage} alt="" className="w-[420px]" />
            </div>
          </div>

          <div className="pb-6 text-center text-sm text-gray-400">
            PT Arunika Medina Pratama
          </div>
        </div>
      </div>
    </div>
  );
}
